import { render } from "./hrm-attendance-policy-modal.vue?vue&type=template&id=7152370c"
import script from "./hrm-attendance-policy-modal.vue?vue&type=script&lang=js"
export * from "./hrm-attendance-policy-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__